<template>
	<div class="alert-card" :style="{ backgroundColor: corDeFundo }">
		<div class="alert-card-title" :style="{ color: corTitulo }">
			<v-icon :color="corTitulo" :size="tamanhoIconeTitulo">{{ iconeTitulo }}</v-icon>
			<span class="alert-card-title__text">
				{{ textoTitulo }}
			</span>
		</div>

		<div class="alert-card-body" :style="{ color: corCorpo }">
			<p v-if="textoCorpo">{{ textoCorpo }}</p>

			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'alert-card',
	props: {
		corDeFundo: {
			type: String,
			default: '#E5F6FD',
		},
		iconeTitulo: {
			type: String,
			default: 'info_outline',
		},
		tamanhoIconeTitulo: {
			type: String,
			default: '16',
		},
		textoTitulo: {
			type: String,
			default: 'Informação',
		},
		corTitulo: {
			type: String,
			default: '#396F87',
		},
		textoCorpo: {
			type: String,
			default: null,
		},
		corCorpo: {
			type: String,
			default: '#0067A5',
		},
	},
}
</script>

<style lang="stylus" scoped>
.alert-card
	padding 10px
	border-radius 8px
	font-size 14px

	.alert-card-title
		display flex
		flex-direction row
		align-items center
		font-weight bold

		.alert-card-title__text
			margin-left 10px

	.alert-card-body
		margin-top 4px
</style>
